import liff from '@line/liff';
import store from '../store';

export default function (to, from, next) {
  if (to.meta.allowPlatform) {
    let currentPlatform = liff.isInClient() ? 'liffApp' : 'web';
    if (to.meta.allowPlatform.includes(currentPlatform)) {
      next();
    } else {
      store.dispatch('user/resetState');
      next('/management');
    }
  } else {
    store.dispatch('user/resetState');
    next('/management');
  }
}
